import React, { Component } from 'react';
import { Button, Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import { Fetcher } from '../../Helpers/fetcher.js';
import { Notify } from '../../Helpers/notification.js';
import { isEmpty } from 'lodash';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { withRouter } from "react-router-dom";
import IVRIllustration from './IVRIllustration.js';

class Login extends Component {
    constructor(props) {
        super(props);
        this.origin = window.location.origin;
        this.state = {
            username: '',
            password: '',
            showPassword: false,
        };
    }

    setvalue = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value
        });
    }

    togglePasswordVisibility = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    loginUser = (e) => {
        e.preventDefault();
        const { username, password } = this.state;
        if (!username || !password) return Notify.notify('Please enter username & password');

        const data = { username, password };
        Fetcher.post(this.props.app.apiPath + '/api/obd/login', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.message === 'Bad credentials') Notify.notify('Wrong username or password');
                else if (!isEmpty(res.token) && !isEmpty(res.userid)) {
                    Notify.notify('Login Successful');
                    this.props.setUserToken(res.userid, res.token, res.role);
                    if (res.role.includes('ROLE_SUSER')) this.props.history.push("/sub-user-report");
                } else Notify.notify('Login Failed');
            })
            .catch(err => {
                console.error('Login error:', err);
                Notify.notify('Login Failed');
            });
    }

    render() {
        const { showPassword } = this.state;

        return (
            <div className="app-container">
                {/* Left Side - Branding Section */}
                <div className="branding-section">
                    <div className="branding-background">
                        <div className="icon ivr-icon"><img src='/Icons/hotspot.png' className="icon-size" /></div>
                        <div className="icon mic-icon" style={{ animationDelay: "1s" }}><img src='/Icons/microphone-black-shape.png' className="icon-size-lg" /></div>
                        <div className="icon headphones-icon" style={{ animationDelay: "2s" }}><img src='/Icons/support.png' className="icon-size-xl" /></div>
                        <div className="icon phone-icon" style={{ animationDelay: "0.5s" }}><img src='/Icons/telephone.png' className="icon-size-md" /></div>
                        <div className="icon volume-icon" style={{ animationDelay: "1.5s" }}><img src='/Icons/microphone-black-shape.png' className="icon-size-lg" /></div>
                        <div className="icon phonecall-icon" style={{ animationDelay: "2.5s" }}><img src='/Icons/telephone.png' className="icon-size" /></div>
                    </div>
                    <div className="branding-content">
                        <div className="branding-logo-title">
                            {/* <div className="branding-logo"><img src='/Icons/telephone.png' className="branding-logo-icon" /></div> */}
                            <h1>Voice/OBD Service</h1>
                        </div>
                        <div className="branding-illustration">
                            <div className="branding-illustration-bg">
                               {/* <IVRIllustration/> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side - Login Form */}
                <div className="login-section">
                    <div className="login-container">
                        <div className="mobile-logo">
                            <div className="mobile-logo-icon"><img src='/Icons/telephone.png' className="mobile-icon" /></div>
                            <div>
                                <h1 className="login-title">Voice/OBD Service</h1>
                                <p className="login-subtitle">Outbound Dialer Panel</p>
                            </div>
                        </div>
                        <div className="login-card">
                            <div className="login-welcome">
                                <div className="user-icon-container">
                                    <div className="user-icon">
                                       {this.props.app.logo ?<img className="navbar-brand-full" src={this.props.app.logo} alt="CoreUI Logo" />: <i className="fa fa-user" aria-hidden="true"></i>}
                                    </div>
                                </div>
                                {/* <h2>Welcome Back</h2> */}
                                <h2 style={{ fontSize: "22px", marginTop: "5px" }}>Login To Your Secure Dashboard</h2>
                            </div>

                            <Form onSubmit={this.loginUser} className="login-form">
                                <Form.Group className="form-group" controlId='username'>
                                    <Form.Label >Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        placeholder="Enter your username"
                                        value={this.state.username}
                                        onChange={this.setvalue}
                                        className="input"
                                        required
										style={{ backgroundColor: "#f8f8f8" }}
                                    />
                                </Form.Group>
                                <Form.Group className="form-group" controlId='password'>
                                    <div className="form-label-row">
                                        <Form.Label >Password</Form.Label>
                                        {this.origin === this.props.app.reportPath && (
                                            <a href="#" className="forgot-link">Forgot Password?</a>
                                        )}
                                    </div>
                                    <div className="password-input-container">
                                        <Form.Control
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Enter your password"
                                            value={this.state.password}
                                            onChange={this.setvalue}
                                            className="input password-input"
											style={{ backgroundColor: "#f8f8f8" }}
                                            required
                                        />
                                        <button
                                            type="button"
                                            onClick={this.togglePasswordVisibility}
                                            className="toggle-password-btn"
                                        >
                                            {showPassword ? 
                                                <i className="fa fa-eye-slash" aria-hidden="true"></i> : 
                                                <i className="fa fa-eye" aria-hidden="true"></i>
                                            }
                                        </button>
                                    </div>
                                </Form.Group>

                                <Button type="submit" className="submit-btn">
                                    Sign In
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Login);